import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  FDIcon,
  FDPaper, FDStack, FDTitleText, tokens,
} from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { PillarLozenge } from 'Views/Page/Content/Templates/ClientDashboardPageTemplate/Organisms/PillarLozenge';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { BodyTextSmall } from 'Packages/FacetDesign/Components';
import { dataAttrs } from 'Helpers/Testing';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('highlightSummaryString', {
    _component: () => BodyTextSmall,
    _customProps: {
      color: 'textDisabled',
    },
  }, overrideReadOnly);

const useStyles = buildUseStyles('FeaturedActionItem', (theme) => ({
  overdueTitle: {
    '& .FD-MuiTypography-title-lg': {
      '& .FD-MuiSvgIcon-root': {
        fontSize: '1em',
        verticalAlign: 'text-bottom', // Makes it look vertically centered
      },
      color: `${tokens.color_maroon_100p} !important`,
    },
  },
  customStyles: {
    '& > div': {
      backgroundColor: tokens.color_grey_30,
      transition: theme.transitions.create(['background-color']),
      '&:hover': {
        cursor: 'pointer',
        backgroundColor: tokens.color_grey_40,
        '& .FD-MuiTypography-title-lg': {
          '& span': {
            textDecoration: 'underline',
          },
        },
      },
    },
  },
}));

export const FeaturedActionItem = ({ actionItemResource, pillarResource, onClick }) => {
  const onComplete = onClick(actionItemResource);
  const isDisabled = !onComplete;
  const isOverdue = actionItemResource.isTruthy('overdue');
  const classes = useStyles();

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div
      className={classNames(classes.customStyles, {
        [classes.overdueTitle]: isOverdue,
      })}
      onClick={onComplete}
    >
      <FDPaper appearance={'elevated'} {...dataAttrs('featured-action-item')}>
        <FDStack paddingX={3} paddingY={2} direction={'column'} spacing={1}>
          <PillarLozenge resource={pillarResource} featured />
          <FDTitleText
            size={'lg'}
            disabled={isDisabled}
            value={(
              <>
                {isOverdue && (<><FDIcon icon="error" color="error" />&nbsp;</>)}
                <span>{`${actionItemResource.attr('name')} →`}</span>
              </>
            )}
            onClick={() => {
              onComplete(actionItemResource);
            }}
            color={'textPrimary'}
          />
          <MetaControl resource={actionItemResource} attrName={'highlightSummaryString'} metaOverrideSet={metaOverrideSet} />
        </FDStack>
      </FDPaper>
    </div>
  );
};

FeaturedActionItem.defaultProps = {
};

FeaturedActionItem.propTypes = {
  actionItemResource: PropTypes.object.isRequired,
  pillarResource: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};
